module.exports = __webpack_public_path__ + "img/logo.c126644a.svg";